<button class="button" (click)="openSidenavMobile()" mat-icon-button fxHide.gt-md>
  <mat-icon class="text-white">menu</mat-icon>
</button>
